import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import { AuthProvider } from "./contexts/AuthContext";
import AppRoutes from "./routes/AppRoutes";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />

        <ToastContainer
          position="top-right"
          autoClose={3000}
          theme="colored"
        />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;